__webpack_require__.p = "/ch-assessment/";